import { useQuery } from "@tanstack/react-query";
import API from "util/API";

// Public restaurant name, alt name and logo for the customer queue pages.
const useRestaurantInfo = (restaurantId) =>
  useQuery({
    queryKey: ["publicRestaurantInfo", restaurantId],
    queryFn: async () => {
      const response = await API.get(`/restaurantInfo?restaurantId=${encodeURIComponent(restaurantId)}`);
      return (response.data && response.data.restaurant) || null;
    },
    enabled: Boolean(restaurantId),
  });

export default useRestaurantInfo;
